import { useState } from 'react';
const FormCheckbox = () => {
  const [firstCheck, setFirst] = useState(false);
  const [secondCheck, setSecond] = useState(true);
  const handleFirst = (event) => {
    console.log(event.target.checked);
    setFirst(event.target.checked);
  };
  const handleSecond = (event) => {
    setSecond(event.target.checked);
  };
  return (
    <div className='checkbox'>
      <div className='checkboxIconsContainer'>
        <input
          className='hiddenCheckbox'
          required
          type='checkbox'
          checked={firstCheck}
          onChange={handleFirst}
          id='uncheckedBox'
        />{' '}
        <label className='checkboxLabel' htmlFor='uncheckedBox'>
          <span className='customization'></span>I agree to the processing of
          personal data
        </label>
      </div>
      <div className='checkboxIconsContainer'>
        <input
          className='hiddenCheckbox'
          id='checkedBox'
          checked={secondCheck}
          onChange={handleSecond}
          type='checkbox'
        />{' '}
        <label className='checkboxLabel' htmlFor='checkedBox'>
          <span className='customization'></span>I agree to use my answers
        </label>
      </div>
    </div>
  );
};

export default FormCheckbox;
